module.exports = __webpack_public_path__ + "static/media/green1.d8aa0099.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/green1.svg
// module id = 1332
// module chunks = 31